<template>
  <q-page padding class=" window-width row justify-center">
    <div class="col-12 col-sm-8">
      <q-form @submit.prevent.stop="reset">
        <q-card>
          <q-toolbar class="bg-primary text-white">
            <q-toolbar-title>Сброс пароля</q-toolbar-title>
          </q-toolbar>
          <q-card-section class="q-gutter-md">
            <q-input v-model="resetUser.email" :rules="[requiredRule]" dense square outlined
                     label="Email"/>
          </q-card-section>
          <q-card-actions>
            <q-btn
                no-caps
                type="submit"
                color="primary"
                label="Сбросить"
                class=" form-button"
            />
            <q-btn
                no-caps
                to="/login"
                label="Вспомнили пароль?"
                color="primary" flat
            />
          </q-card-actions>
        </q-card>
      </q-form>

    </div>
  </q-page>
</template>

<script setup lang="ts">
import {reactive} from "vue"
import {useReset} from "../composables/auth";
import {requiredRule} from "../util/rules"
import {useQuasar} from "quasar";
import {ResetRequest} from "../models/auth";

const resetUser: ResetRequest = reactive({email: ""})

const $q = useQuasar()
const {execute} = useReset(resetUser)

async function reset() {
  await execute(true)
  $q.dialog({
    message: "На вашу почта отправлена ссылка для сброса",
    ok: {
      to: "/login",
      flat: true
    },
    cancel: false,
    persistent: true
  })
}
</script>

<style scoped>

</style>